<template>
  <v-edit-dialog
    large
    @save="save"
    @open="open"
    height="350px"
    save-text="Salvar"
    cancel-text="Cancelar">
    {{ compra.dataPrevisaoEntrega | date }}
    <template v-slot:input>
      <div class="mt-5">
        <px-date-picker dense
                        label="Previsão de entrega"
                        input-class="rounded-tag-small"
                        v-model="dataPrevisao"/>
      </div>
    </template>
  </v-edit-dialog>
</template>

<script>
import CompraService from './compra-service';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dataPrevisao: null,
    };
  },
  computed: {},
  methods: {
    savePrevisaoEntrega() {
      CompraService.savePrevisaoEntrega(this.compra.id, {
        dataPrevisaoEntrega: this.dataPrevisao,
      }).then(() => {
        this.$emit('change');
      });
    },
    save() {
      this.savePrevisaoEntrega();
    },
    open() {
      this.dataPrevisao = this.compra.dataPrevisaoEntrega;
    },
  },
};
</script>
